/**
 * 构建权限路由树
 */
// import { cloneDeep } from 'lodash'

// 构建权限管理树
export const generateTree = (router: any, fisrtRouter: any, secondRouter: any) => {
  let routerList = Object.entries(router).map(item => {
    return {
      id: item[0],
      name: fisrtRouter[item[0]] ? fisrtRouter[item[0]] : '未知一级路由',
      pid: '',
      isEdit: false,
      children: Object.keys(item[1] as any).map(item1 => {
        return {
          id: item1,
          name: secondRouter[item1] ? secondRouter[item1] : '未知二级路由',
          pid: item[0],
          isEdit: false,
          children: (item[1] as any)[item1].map((item2: { id: any, option:any }) => {
            return {
              id: item2.id,
              name: item2.option ? item2.option : '未知三级路由',
              pid: item1,
              isEdit: false,
              children: []
            }
          })
        }
      })
    }
  })
  return routerList
}

// 构建角色权限树
export const generatePermissionTree = (router: any, fisrtRouter: any, secondRouter: any) => {
  let routerList = Object.entries(router).map(item => {
    return {
      id: item[0],
      name: fisrtRouter[item[0]] ? fisrtRouter[item[0]] : '未知一级路由',
      isUse: false,
      children: Object.keys(item[1] as any).map(item1 => {
        return {
          id: item1,
          name: secondRouter[item1] ? secondRouter[item1] : '未知二级路由',
          isUse: false,
          children: (item[1] as any)[item1].map((item2: { id: any, option:any, isUse: number }) => {
            return {
              id: item2.id,
              name: item2.option ? item2.option : '未知三级路由',
              isUse: item2.isUse === 1,
              children: []
            }
          })
        }
      })
    }
  })
  return routerList
}
